import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getCurrentUser } from 'services/userService';
import { User } from '../../types';

export const useLoggedinUser = () => {
    // Check if token exists in localStorage
    const token = localStorage.getItem('token');
    
    const query = useQuery<User>({
        queryKey: ['loggedinUser'],
        queryFn: getCurrentUser,
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes (formerly cacheTime)
        enabled: !!token, // Only run the query if token exists
        retry: false, // Don't retry if the query fails
    });

    // // Handle localStorage operations with useEffect
    useEffect(() => {
        if (query.isSuccess && query.data ) {
            localStorage.setItem('user_name', query.data.name);
            localStorage.setItem('email', query.data.email_address);
        } else if (query.isError) {
            localStorage.removeItem('user_name');
            localStorage.removeItem('email');
        }
    }, [query.isSuccess, query.isError, query.data, query.error]);

    return query;
}; 
